/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Snackbar, Box, Chip, IconButton, Menu, MenuItem } from '@mui/material';
import { Alert } from '@mui/lab';
import axios from 'lib/axios';
import Reacts from '../../components/Reacts';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import NoticeModal from 'components/modals/Notice';
import ThreeDot from '../../assets/static_images/threedot.svg';
import Like from '../../assets/static_images/like.svg';
import Love from '../../assets/static_images/love.svg';
import Haha from '../../assets/static_images/haha.svg';
import Wow from '../../assets/static_images/wow.svg';
import Sad from '../../assets/static_images/sad.svg';
import Angry from '../../assets/static_images/angry.svg';
import Blank from '../../assets/static_images/blank.svg';

import NoticeIcon from '../../assets/static_images/megaphone.svg';
import NoticeGalleryModal from 'components/modals/NoticeGalleryModal';
import ViewReactModal from 'components/modals/ViewReactModal';
import { convertDateAndTime } from 'Helpers';
import { useLocation } from 'react-router-dom';
import ImageViewerModal from 'components/modals/ImageViewerModal';
import { FiBell, FiClock, FiImage } from 'react-icons/fi';
import { BsBellFill } from 'react-icons/bs';

const Notice = ({ notice, reacts, setNoticeList, single = false, type }) => {
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    const query = useQuery();
    const noticeId = query.get('notice_id');
    const [reactOpen, setReactOpen] = useState(false);
    const [reacted, setReacted] = useState(false);
    const [reaction, setReaction] = useState(null);
    const [reactionImg, setReactionImg] = useState(Blank);
    const [reactCount, setReactCount] = useState(notice?.notice_reacts?.length);
    const [openGallery, setOpenGallery] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [openSnack, setShowSnack] = useState(false);
    const [snackOptions, setSnackOptions] = useState({ isError: false, message: '' });

    const [openViewReactModal, setOpenViewReactModal] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const currentUserId = JSON.parse(window.localStorage.getItem('authUser'))?.user_id;
    const isCreator = currentUserId == notice?.user_id;

    function handleSnackClose() {
        setShowSnack(false);
    }

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const [id, setId] = useState(`notice-${notice?.notice_id}`);

    function urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text?.replace(urlRegex, function (url) {
            return '<a target="_target" style="color: #1E7C88;" href="' + url + '">' + url + '</a>';
        });
    }

    useEffect(() => {
        axios.get(`notice/reacted/${notice.notice_id}`).then(({ data }) => {
            if (data.success) {
                setReacted(data.reacted);
                if (data.react !== null) {
                    setReaction(data.react.react.react_name);
                    if (data.react.react.react_id == 1) {
                        setReactionImg(Like);
                    } else if (data.react.react.react_id == 2) {
                        setReactionImg(Love);
                    } else if (data.react.react.react_id == 3) {
                        setReactionImg(Haha);
                    } else if (data.react.react.react_id == 4) {
                        setReactionImg(Wow);
                    } else if (data.react.react.react_id == 5) {
                        setReactionImg(Sad);
                    } else if (data.react.react.react_id == 6) {
                        setReactionImg(Angry);
                    }
                }
            }
        });

        // fetchComments();
    }, []);
    const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };

    const isToday = new Date(notice.createdAt).toDateString() === new Date().toDateString();
    console.log('notice', reactCount);
    return (
        <Grid item sm={12} id={() => id}>
            <Card
                sx={{
                    borderRadius: '12px',
                    padding: '1.5rem',
                    width: '100%',
                    border: noticeId && noticeId == notice.notice_id ? '2px solid #1E7C88' : '1px solid rgba(30, 124, 136, 0.3)',
                    position: 'relative',
                    boxShadow: 'none',
                    mb: 2,
                    backgroundColor: '#fff'
                }}
            >
                <Grid container spacing={0} sx={{ padding: '0px' }} display="flex" direction="column" sm={12}>
                    {/* Card Header */}
                    <Grid item sm={12}>
                        <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                            <Box
                                sx={{
                                    backgroundColor: 'rgba(30, 124, 136, 0.1)',
                                    borderRadius: '10px',
                                    p: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <BsBellFill size={20} color="#1E7C88" />
                            </Box>

                            <Box sx={{ ml: 1.5, flex: 1 }}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: '#1E7C88',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        mb: 0.5
                                    }}
                                >
                                    Official Notice
                                </Typography>
                                <Box display="flex" alignItems="center">
                                    <FiClock size={14} color="#666" style={{ marginRight: '2px' }} />
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: '#666',
                                            fontSize: '0.8rem'
                                        }}
                                    >
                                        {convertDateAndTime(notice.createdAt)}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box display="flex" alignItems="center" gap={1}>
                                {noticeId && noticeId == notice.notice_id && (
                                    <Chip
                                        label="New Notice"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#1E7C88',
                                            color: 'white',
                                            fontSize: '0.75rem',
                                            fontWeight: 500
                                        }}
                                    />
                                )}
                                {isToday && !(noticeId && noticeId == notice.notice_id) && (
                                    <Chip
                                        label="Today"
                                        size="small"
                                        sx={{
                                            backgroundColor: 'rgba(30, 124, 136, 0.1)',
                                            color: '#1E7C88',
                                            fontSize: '0.75rem',
                                            fontWeight: 500,
                                            border: '1px solid rgba(30, 124, 136, 0.2)'
                                        }}
                                    />
                                )}
                                {isCreator && (
                                    <IconButton
                                        onClick={handleMenuOpen}
                                        size="small"
                                        aria-controls={Boolean(anchorEl) ? 'notice-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                                    >
                                        <img src={ThreeDot} alt="dot" />
                                    </IconButton>
                                )}
                            </Box>
                            <Menu
                                id="notice-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                MenuListProps={{
                                    'aria-labelledby': 'notice-menu-button'
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        handleMenuClose();
                                        setOpenEditor(true);
                                    }}
                                >
                                    Edit
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Grid>

                    {/* Card Body */}
                    <Grid item sm={12}>
                        {/* Title */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                color: '#333',
                                mb: 1.5,
                                fontSize: '1.1rem',
                                lineHeight: 1.4
                            }}
                        >
                            {notice.notice_title}
                        </Typography>

                        {/* Content */}
                        <Box sx={{ mb: 2 }}>
                            {urlify(notice.plain_text_body)?.length > 150 ? (
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#555',
                                            lineHeight: 1.6,
                                            mb: 1,
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word'
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: showMore
                                                ? urlify(notice.plain_text_body)
                                                : `${urlify(notice.plain_text_body).substring(0, 150)}...`
                                        }}
                                    />
                                    <Button
                                        size="small"
                                        sx={{
                                            color: '#1E7C88',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            p: 0,
                                            minWidth: 'auto'
                                        }}
                                        onClick={() => setShowMore(!showMore)}
                                    >
                                        {showMore ? 'Show less' : 'Show more'}
                                    </Button>
                                </Box>
                            ) : (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#555',
                                        lineHeight: 1.6,
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word'
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: urlify(notice.plain_text_body)
                                    }}
                                />
                            )}
                        </Box>

                        {/* Image */}
                        {notice.images && notice.images != '' && (
                            <Box
                                sx={{
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '1px solid rgba(0, 0, 0, 0.08)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden'
                                }}
                                onClick={() => setOpenGallery(true)}
                            >
                                <img
                                    src={notice.images[0]}
                                    style={{
                                        height: '250px',
                                        width: '100%',
                                        objectFit: 'cover'
                                    }}
                                    alt="notice-attachment"
                                />
                            </Box>
                        )}
                    </Grid>

                    {/* reaction section  */}
                    <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom="0.5rem" sx={{ marginTop: '1rem' }}>
                        <Box display="flex" alignItems="center" gap="1rem">
                            <Box display="flex" alignItems="center">
                                <Box display="flex" alignItems="center" sx={{ position: 'relative' }}>
                                    <Box
                                        className="cursor-pointer"
                                        onMouseEnter={() => setReactOpen(true)}
                                        onMouseLeave={() => setReactOpen(false)}
                                        onClick={() => {
                                            // If already reacted, remove the reaction
                                            if (reacted) {
                                                axios
                                                    .delete(`/notice-react/${notice.notice_id}`)
                                                    .then(({ data }) => {
                                                        if (data.success) {
                                                            setReacted(false);
                                                            setReaction(null);
                                                            setReactionImg(Blank);
                                                            setReactCount((prev) => prev - 1);
                                                            setSnackOptions({ isError: false, message: 'Reaction removed' });
                                                            setShowSnack(true);
                                                        }
                                                    })
                                                    .catch((err) => {
                                                        console.log(err);
                                                        setSnackOptions({ isError: true, message: 'Failed to remove reaction' });
                                                        setShowSnack(true);
                                                    });
                                            }
                                        }}
                                    >
                                        <Box>
                                            {reacted ? (
                                                <Box display="flex" alignItems="center" gap="0.3rem">
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <img
                                                            src={reactionImg}
                                                            alt="icn"
                                                            style={{
                                                                height: '1rem',
                                                                width: '1rem'
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>{reaction}</Typography>
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Box display="flex" alignItems="center" gap="0.3rem">
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <img
                                                            src={Blank}
                                                            alt="icn"
                                                            style={{
                                                                height: '1rem',
                                                                width: '1rem'
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>Like</Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                    {reactOpen ? (
                                        <Box
                                            sx={{
                                                zIndex: '1024',
                                                position: 'absolute',
                                                top: '-4rem',
                                                left: '1.5rem',
                                                width: '20rem'
                                            }}
                                            onMouseEnter={() => setReactOpen(true)}
                                            onMouseLeave={() => setReactOpen(false)}
                                        >
                                            <Reacts
                                                modelValue={notice}
                                                reacts={reacts}
                                                setReactOpen={setReactOpen}
                                                setReacted={setReacted}
                                                setReactCount={setReactCount}
                                                setReactionImg={setReactionImg}
                                                setReaction={setReaction}
                                                model={'notice'}
                                            />
                                        </Box>
                                    ) : (
                                        <></>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                        {/* <Box
                            className="cursor-pointer"
                            onClick={() => {
                                setOpenViewReactModal(true);
                            }}
                        >
                            <Typography sx={{ opacity: '0.6', fontSize: '0.85rem' }}>
                                {reactCount > 0 ? `${reactCount} ${reactCount > 1 ? 'Reactions' : 'Reaction'}` : '0 Reactions'}
                            </Typography>
                        </Box> */}
                    </Box>
                    {/* stats section  */}
                    <Box
                        display="flex"
                        alignItems="center"
                        sx={{ gap: '0.25rem', cursor: 'pointer' }}
                        onClick={() => {
                            setOpenViewReactModal(true);
                        }}
                    >
                        {reacted ? <Typography variant="subtitle1">You</Typography> : <></>}
                        {reactCount > 0 && (
                            <Typography variant="h6">
                                {reacted ? 'and' : ''} {reactCount} {reactCount > 1 ? "other's" : 'other'}
                            </Typography>
                        )}
                        {(reactCount > 0 || reacted) && <Typography variant="subtitle1">reacted on this notice</Typography>}
                    </Box>
                </Grid>
            </Card>

            {openGallery && <ImageViewerModal onClose={() => setOpenGallery(false)} open={openGallery} images={notice.images} />}
            {openViewReactModal && (
                <ViewReactModal
                    post={notice}
                    endpoint="/notice-reacts/list"
                    setOpenModal={setOpenViewReactModal}
                    openModal={openViewReactModal}
                    type="notice"
                />
            )}
            {openEditor && (
                <NoticeModal
                    notice={notice}
                    isOpen={openEditor}
                    setOpenEditor={setOpenEditor}
                    operation="update"
                    setNotices={setNoticeList}
                    showSnack={(isError, message) => {
                        setSnackOptions({ isError, message });
                        setShowSnack(true);
                    }}
                />
            )}
            <Snackbar
                open={openSnack}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackClose} severity={snackOptions.isError ? 'error' : 'success'}>
                    {snackOptions.message}
                </Alert>
            </Snackbar>
        </Grid>
    );
};

export default Notice;
